//
//
//
//
//
//
//
//
//

export default {
	name: "CustomResult",
	props: {
		result: Object
	},
	data() {
		return {
			
		}
	},
	computed: {
		targetValue() {
			return this.result.openInNewWindow ? "_blank" : "";
		},
		typeShort() {
			return this.result.result.contentType.split(".")[1];
		},
		typeLabel() {
			let type;
			switch (this.typeShort) {
				case "BlogDetailPage":
					type = "Blog Detail Page";
					break;
				case "LocationDetailPage":
					type = "Location Detail Page";
					break;
				default:
					type = "Content Page";
			}
			return "This result is a " + type;
		},
		typeIconClass() {
			return "search-result__icon--" + this.typeShort; 
		}
	},
	methods: {
		
	},
	created() {
		
	}
}
